














































import { Vue, Component, Prop } from 'vue-property-decorator';
import idealName from '@/utils/ideal-name';
import Chronometer from '@/atomics/Chronometer.vue';
import Icon from '@/components/Icon.vue';
import Tooltip from '@/components/Tooltip.vue';

export enum Direction {
    Inbound = 'inbound',
    Outbound = 'outbound'
}

@Component({
    components: {
        Chronometer,
        Icon,
        Tooltip,
    },
})
export default class Call extends Vue {
    @Prop(Boolean) readonly moreDetail!: boolean;

    @Prop(String) readonly chronometerId!: string;

    @Prop(String) readonly callId!: string;

    @Prop(String) readonly icon!: string;

    @Prop(String) readonly content!: string;

    @Prop(Number) time!: number;

    @Prop(String) readonly did!: string;

    idealName = idealName;

    get effectiveChronoId(): string {
        return this.chronometerId || this.callId || this.content || 'call-chrono';
    }

    onChronoRunning(running: boolean) {
        this.$emit('call-chrono', { id: this.effectiveChronoId, running });
    }
}
